import { Action } from '../../../common/actions/core/action';

export class OpenStudentRejectedAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/rejected/rejected.action.ts